// Textos de las pestañas de la ficha de usuario del backoffice (user-detail-tabs). Se registran junto al
// resto de vocabularios en AppComponent; setTranslation los fusiona.
export const locale = {
  lang: 'en',
  data: {
    USER_DETAIL_TABS: {
      ROUTES: {
        VIEW_FRAUD_TAB: 'With fraud signals',
        SIGNAL_TRIPS_NONE_SENTENCE: 'No trips with signals.',
        DECISION_IN_FRAUD: 'The decision is made in Fraud.',
        SHOWING: 'Showing {{count}} of {{total}} trips',
        SHOWING_FRAUD: 'Showing {{count}} of {{total}} trips with signals (the most suspicious)',
        TITLE: 'Trips',
        SUBTITLE:
          'User trips as driver or passenger. Click one to see who was in the car; the › arrow opens the trip.',
        RELOAD: 'Reload',
        SEARCH_PLACEHOLDER: 'Search by routine…',
        SEARCH_ARIA: 'Search by routine',
        ROLE_ARIA: 'Role',
        ROLE_ALL: 'Role: all',
        ROLE_DRIVER: 'Driver',
        ROLE_RIDER: 'Passenger',
        UNVERIFIED_IDENTITY: 'Unverified identity',
        UNVERIFIED_IDENTITY_HINT: 'Made this trip without a verified identity',
        ALL: 'All',
        STATUS_ARIA: 'Trip status',
        STATUS_ALL: 'Status: all',
        FOOTPRINT_ARIA: 'Footprint',
        FOOTPRINT_DEFAULT: 'Footprint: all',
        FOOTPRINT_VERIFIED: 'Verified',
        FOOTPRINT_REJECTED: 'Rejected',
        FOOTPRINT_PENDING: 'Pending',
        FOOTPRINT_DECIDED: 'Verified or rejected',
        FOOTPRINT_FACE_HOLD: 'On hold',
        FOOTPRINT_FACE_HOLD_HINT: 'On hold for face verification until {{date}}. The footprint is not verified until then.',
        FOOTPRINT_FACE_HOLD_HINT_NO_DATE: 'On hold for face verification. The release date is set on the first verification pass.',
        FOOTPRINT_APP_VERIFYING: "In the app: «Verificando»",
        FOOTPRINT_VERIFYING_HINT: "Verified, but the driver has not been paid yet (payout deferred by cash delay or reinforced verification). Until then the app shows «Verificando».",
        NO_FOOTPRINT: 'No footprint',
        FROM: 'From',
        TO: 'To',
        CLEAR_FILTERS: 'Clear filters',
        LOADING: 'Loading trips…',
        RETRY: 'Retry',
        EMPTY_FILTERED: 'No trips match the filters.',
        EMPTY: 'This user has no trips.',
        TH_DATE: 'Date',
        TH_ROUTE: 'Route',
        TH_ROLE: 'Role',
        CAR_SHOW: 'See who was in the car',
        CAR_HIDE: 'Hide the car',
        CAR_LOADING: 'Loading the car…',
        CAR_ERROR: 'Could not load who was in the car.',
        CAR_PICKUP_ORDER: 'pickup #{{n}}',
        CAR_PEOPLE_ONE: '{{n}} person',
        CAR_PEOPLE_MANY: '{{n}} people',
        CAR_TITLE: 'In the car',
        CAR_PAYS: 'Pays',
        CAR_EARNS: 'Earns',
        CAR_THIS_USER: 'This user',
        TH_ROUTINE: 'Routine',
        TH_STATUS: 'Status',
        TH_FOOTPRINT: 'Footprint',
        OPEN: 'Open',
        VIEW_TRIP: 'View trip',
        PAGE: 'Page',
        OF: 'of',
        PREV_PAGE: 'Previous page',
        NEXT_PAGE: 'Next page',
        OPT_PENDING: 'Pending',
        OPT_IN_PROGRESS: 'In progress',
        OPT_COMPLETED: 'Completed',
        OPT_CANCELLED: 'Cancelled',
        OPT_VERIFIED: 'Verified',
        STATUS_PENDING: 'Pending',
        STATUS_IN_PROGRESS: 'In progress',
        STATUS_COMPLETED: 'Completed',
        STATUS_CANCELLED: 'Cancelled',
        STATUS_VERIFIED: 'Verified',
        STATUS_REJECTED: 'Rejected',
        STATUS_DELETED: 'Deleted',
        STATUS_DELETED_F: 'Deleted',
        SEATS_OCCUPANTS: '{{n}} occupants',
        SEATS: '{{current}}/{{available}} seats',
        ERROR_LOAD: "The user's trip list could not be loaded.",
        PAGINATION: '{{from}}-{{to}} of {{total}}',
        FRAUD_TITLE: 'Fraud:',
        SCORE: 'Score',
        SIGNAL_TRIPS_NONE: 'no trips with signals',
        SIGNAL_TRIPS_ONE: '{{n}} trip with signals',
        SIGNAL_TRIPS_MANY: '{{n}} trips with signals',
        MANAGE_FRAUD: 'Manage in Fraud',
        VIEW_ARIA: 'Trips to show',
        VIEW_ALL: 'All trips',
        VIEW_FRAUD: 'With fraud signals ({{n}})',
        TH_PASSENGERS: 'Passengers',
        TH_SIGNALS: 'Signals',
        TH_MONEY: 'Money',
        TH_MODE: 'Mode',
        TH_FRAUD: 'Fraud',
        DRIVER_COLON: 'Driver:',
        NO_MATCH: 'No match',
        NO_PRICE: 'No price',
        FREE_TRIP: 'Free trip',
        UNTIL: 'until {{date}}',
        SHOWING_MOST: 'Showing the {{shown}} most suspicious of {{total}}.',
        LOW_SIGNALS: 'Low signals',
        ERROR_FRAUD: 'The fraud information could not be loaded.',
        COLLUSION_PAIRS_TITLE: 'Collusion by pair',
        COLLUSION_PAIRS_TEXT: 'Who they do not seem independent from, according to the data team. Higher = worse.',
        TH_PERSON: 'Person',
        TH_COLLUSION: 'Collusion',
        TH_TRIPS_TOGETHER: 'Trips together',
        TH_LAST_VALUE: 'Latest value',
        TH_HISTORY: 'History',
        HISTORY_SHOW: 'History ({{n}})',
        HISTORY_HIDE: 'Hide history',
        TRIPS_TOGETHER_N: '{{n}} trips together',
        PAYOUT_PAID: 'Paid',
        PAYOUT_HELD: 'Held',
        PAYOUT_UNPAID: 'Not collected',
        FRAUD_BLACKLIST: 'Blacklist',
        FRAUD_WHITELIST: 'Whitelist',
        FRAUD_REINFORCED_NOCOST: 'Reinforced + no zero cost',
        FRAUD_REINFORCED: 'Reinforced verification',
        FRAUD_NOCOST: 'No zero cost',
        FRAUD_ALLOW: 'Not fraud',
        FRAUD_NONE: 'No decision',
        SIG_GPS: 'GPS',
        SIG_COLLISION: "Collusion",
        SIG_COPRESENCE: 'Co-presence',
        SIG_NETWORK: 'Network/IP',
        SIG_TRANSPORT: 'Transport',
      },
      MOVEMENTS: {
        SHOWING: 'Showing <b>{{count}}</b> of <b>{{total}}</b> movements',
        TITLE: 'Wallet movements',
        SUBTITLE:
          'Payments for the same trip are grouped into one row; expand it to see how much each passenger paid.',
        RELOAD: 'Reload',
        NOT_GROUPED:
          'The backend in this environment does not group payments by trip yet: they are shown one by one.',
        LOADING: 'Loading movements…',
        RETRY: 'Retry',
        EMPTY: 'This user has no movements in their wallet.',
        EXPAND: 'Expand',
        TH_DATE: 'Date',
        TH_TYPE: 'Type',
        TH_CONCEPT: 'Description',
        TH_AMOUNT: 'Amount',
        TH_BALANCE: 'Balance after movement',
        NO_NAME: 'Passenger without name',
        BALANCE: 'Balance',
        PAGE: 'Page',
        OF: 'of',
        PREV_PAGE: 'Previous page',
        NEXT_PAGE: 'Next page',
        PAGINATION: '{{from}}–{{to}} of {{total}}',
        ERROR_LOAD: "The user's wallet movements could not be loaded.",
        TYPES: {
          withdrawal: 'Withdrawal',
          instant_withdrawal: 'Instant withdrawal',
          instant_payout_fee: 'Instant withdrawal fee',
          instant_payout_refund: 'Instant withdrawal refund',
          income: 'Top-up',
          waiis_commission: 'WAIIS commission',
          trip_income: 'Trip income',
          trip_payment: 'Trip payment',
          saas_commission: 'SaaS subscription commission',
          manual_income: 'Manual deposit',
          manual_withdrawal: 'Manual withdrawal',
          other: 'Other',
        },
        CONCEPT: {
          TRIP_GROUPED_ONE: 'Shared trip · {{count}} passenger',
          TRIP_GROUPED_OTHER: 'Shared trip · {{count}} passengers',
          withdrawal: 'Withdrawal #{{id}}',
          instant_withdrawal: 'Instant withdrawal #{{id}}',
          instant_payout_fee: 'Instant withdrawal fee · transfer #{{id}}',
          instant_payout_refund: 'Instant withdrawal refund',
          income: 'Top-up #{{id}}',
          waiis_commission: 'WAIIS commission · transfer #{{id}}',
          trip_income: 'Trip income · transfer #{{id}}',
          saas_commission: 'SaaS subscription commission · transfer #{{id}}',
          trip_payment: 'Trip payment',
          other: 'Other movement',
        },
      },
      DEPOSIT: {
        SAVING: 'Saving…',
        ERROR_SAVE_TITLE: 'The movement could not be saved',
        TITLE: 'New wallet movement',
        SUBTITLE:
          'Add or withdraw balance manually. The user will see the reason in their movements.',
        KIND_ARIA: 'Movement type',
        KIND_DEPOSIT: 'Deposit',
        KIND_DEPOSIT_HINT: 'Adds balance to the user',
        KIND_WITHDRAW: 'Withdrawal',
        KIND_WITHDRAW_HINT: 'Deducts balance from the user',
        AMOUNT: 'Amount',
        REASON: 'Reason',
        REASON_PLACEHOLDER: 'Explain why the movement is made',
        REASON_1: 'Compensation for an incident on a trip',
        REASON_2: 'Refund of a duplicate charge',
        REASON_3: 'Promotional bonus',
        REASON_4: 'Balance correction',
        PROCESSING: 'Processing…',
        ACTION_WITHDRAW: 'Withdraw balance',
        ACTION_DEPOSIT: 'Add balance',
        PREVIEW_ARIA: 'Balance preview',
        SUMMARY: 'Summary',
        CURRENT_BALANCE: 'Current balance',
        NOT_AVAILABLE: 'Not available',
        BALANCE_AFTER: 'Balance after the movement',
        EXCEEDS: "The withdrawal exceeds the user's balance.",
        LOGGED_WITHDRAW:
          'It is recorded as "Manual withdrawal" in the Movements tab.',
        LOGGED_DEPOSIT:
          'It is recorded as "Manual deposit" in the Movements tab.',
        OK: 'OK',
        ERROR_TITLE: 'Error',
        SUCCESS_WITHDRAW_TITLE: 'Withdrawal completed',
        SUCCESS_DEPOSIT_TITLE: 'Deposit completed',
        SUCCESS_WITHDRAW_TEXT:
          "The amount has been successfully withdrawn from the user's wallet.",
        SUCCESS_DEPOSIT_TEXT:
          "The amount has been successfully added to the user's wallet.",
        ERROR_MOVEMENT:
          "The movement in the user's wallet could not be completed.",
        ERR_REQUIRED: 'This field is required',
        ERR_POSITIVE: 'Enter an amount greater than 0',
        ERR_MAXLENGTH: 'The reason cannot exceed 255 characters',
        ERR_INVALID: 'Invalid field',
        TITLE_CREDITS: 'New credits movement',
        SUBTITLE_CREDITS: 'Add or remove app credits. The user will see "Manual deposit" or "Manual withdrawal" in their credits history; the reason is only visible to the team.',
        TARGET_ARIA: 'What do you want to move',
        TARGET_WALLET: 'Balance (€)',
        TARGET_CREDITS: 'Credits',
        KIND_DEPOSIT_HINT_CREDITS: 'Adds credits to the user',
        KIND_WITHDRAW_HINT_CREDITS: 'Removes credits from the user',
        AMOUNT_CREDITS: 'Credits',
        SUFFIX_CREDITS: 'cr.',
        ERR_INTEGER: 'Credits must be a whole number',
        CURRENT_CREDITS: 'Current credits',
        CREDITS_AFTER: 'Credits after the movement',
        EXCEEDS_CREDITS: "The withdrawal exceeds the user's credits.",
        LOGGED_WITHDRAW_CREDITS: 'It is recorded as "Manual withdrawal" in the Movements tab (credits).',
        LOGGED_DEPOSIT_CREDITS: 'It is recorded as "Manual deposit" in the Movements tab (credits).',
        ACTION_WITHDRAW_CREDITS: 'Withdraw credits',
        ACTION_DEPOSIT_CREDITS: 'Add credits',
        CREDIT_ONE: 'credit',
        CREDIT_MANY: 'credits',
        SUCCESS_WITHDRAW_TEXT_CREDITS: "The amount has been successfully withdrawn from the user's credits.",
        SUCCESS_DEPOSIT_TEXT_CREDITS: "The amount has been successfully added to the user's credits.",
      },
      CREDITS: {
        SHOWING: 'Showing <b>{{count}}</b> of <b>{{total}}</b> movements',
        TITLE: 'Credits movements',
        SUBTITLE: 'App credits (bonuses, incentives, coupons and manual adjustments).',
        CURRENT_BALANCE: 'Current balance',
        CREDITS_LOWER: 'credits',
        RELOAD: 'Reload',
        LOADING: 'Loading credits…',
        RETRY: 'Retry',
        EMPTY: 'This user has no credits movements.',
        TH_DATE: 'Date',
        TH_TYPE: 'Type',
        TH_REASON: 'Reason',
        TH_CREDITS: 'Credits',
        TH_BALANCE: 'Balance after movement',
        NO_TYPE: 'No type',
        BY: 'by {{name}}',
        PAGE: 'Page',
        OF: 'of',
        PREV_PAGE: 'Previous page',
        NEXT_PAGE: 'Next page',
        ERROR_LOAD: "The user's credits could not be loaded.",
        TYPES: {
          VERIFY_ROUTINE: 'Routine verification',
          CREATE_ROUTINE: 'Routine created',
          TRIP_PAYMENT: 'Trip paid with credits',
          TRIP_BONUS: 'Completed trip bonus',
          RIDER_FINISHED_TRIP: 'Passenger trip completed',
          COUPON_EXCHANGE: 'Coupon redeemed',
          SUBSIDY_REFUND: 'Corporate subsidy refund',
          INCENTIVE_VERIFY_DNI: 'Welcome bonus · ID verification',
          INCENTIVE_NO_TRIPS: 'First trip bonus',
          INCENTIVE_INACTIVE: 'Reactivation bonus',
          MANUAL_CREDIT_INCOME: 'Manual credit deposit',
          MANUAL_CREDIT_WITHDRAWAL: 'Manual credit withdrawal',
        },
      },
    },
  },
};
